import PropTypes from 'prop-types';
import styles from './Hero.module.scss';

/**
 * Page Hero
 */
export default function Hero({
  heading, content, image, children, offset,
}) {
  const containerClassName = [
    styles.hero__container,
    offset ? styles['--offset'] : '',
  ].join(' ').trim();

  return (
    <div className={styles.hero}>
      <div className={containerClassName}>
        <div className={styles.hero__wrapper}>
          <div className={styles.hero__content}>
            {heading && (
            <h1 className={styles.hero__heading}>{heading}</h1>
            )}
            {content && (
            <p>{content}</p>
            )}
            {children}
          </div>
        </div>
        <div className={styles.hero__image}>
          {image}
        </div>
      </div>
    </div>
  );
}

Hero.defaultProps = {
  heading: '',
  content: '',
  image: null,
  children: null,
  offset: false,
};

Hero.propTypes = {
  /**
   * Hero Heading
   */
  heading: PropTypes.string,
  /**
   * Hero content
   */
  content: PropTypes.string,
  /**
   * Hero image
   */
  image: PropTypes.node,
  children: PropTypes.node,
  /**
   * Hero is not a 50/50 split
   */
  offset: PropTypes.bool,
};
